import { render, staticRenderFns } from "./LeaseArea.vue?vue&type=template&id=5d954b8a"
import script from "./LeaseArea.vue?vue&type=script&lang=js"
export * from "./LeaseArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports